var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GiantTree',{attrs:{"nodes":_vm.treeData},on:{"onCreated":_vm.onTreeCreated,"onClick":_vm.onTreeNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }